import { TableColumn } from "../../types/table-column";

export const productUseCasesColumns: TableColumn[] = [
  {
    type: "string",
    fieldName: "AI_SCENARIO",
    value: "title",
    secondaryValue: "internalId",
    width: 45,
  },
  {
    type: "release",
    fieldName: "RELEASE",
    value: "release",
    width: 8,
  },
  {
    type: "object",
    fieldName: "RISK",
    value: "riskLevel",
    width: 15,
  },
  {
    type: "userObj",
    fieldName: "CONTACT",
    value: "keyContactUser",
    secondaryValue: "email",
    width: 20,
  },
  {
    type: "date",
    fieldName: "LAST_MODIFIED",
    value: "updatedAt",
    width: "fit-content",
  },
];
